import {
  Label,
  SelectBase,
  SelectBaseListBox,
  SelectBasePopover,
  SelectBaseTriggerButton,
  SelectBaseValue,
  SelectItem,
  Text,
} from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

import { EDITOR_ITEM, VIEWER_ITEM } from "../../constants";
import { RoleDefinitions, SelectablePermission } from "./../../types";

import styles from "./RoleDropdown.module.css";

type Props = {
  initialSelectedItem: typeof VIEWER_ITEM | typeof EDITOR_ITEM;
  hasEditorAndViewerRoles: boolean;
  roleDefinitions: RoleDefinitions;
  onChange: (selectedRole: SelectablePermission) => void;
  /** Host dialog element for portals when nested in ModalDialog. */
  portalContainer?: Element;
};

export default function RoleDropdown({
  initialSelectedItem,
  hasEditorAndViewerRoles,
  roleDefinitions,
  onChange,
  portalContainer,
}: Props) {
  return (
    <div className={styles.searchInputCol2}>
      <SelectBase
        defaultSelectedKey={initialSelectedItem.value}
        onChange={(key) => onChange(key as SelectablePermission)}
      >
        <Label>Role</Label>
        <SelectBaseTriggerButton>
          <SelectBaseValue />
          <Icon name="arrowDropdown" color="TextWeakest" size={20} />
        </SelectBaseTriggerButton>
        {/* Nested ModalDialog: isNonModal avoids a second focus trap;
            portal into the dialog so the list isn't aria-hidden on body.
            width: auto so the popover can grow wider than the trigger. */}
        <SelectBasePopover
          isNonModal
          UNSTABLE_portalContainer={portalContainer}
          style={{ width: "auto", minWidth: "max-content" }}
        >
          <SelectBaseListBox>
            <SelectItem
              value={EDITOR_ITEM.value}
              textValue={EDITOR_ITEM.label}
              className={styles.selectItem}
            >
              <div className={styles.itemContent}>
                <Text type="Body2" color="inherit" className={styles.itemLabel}>
                  {EDITOR_ITEM.label}
                </Text>
                <Text
                  type="SmallPrint1"
                  color="inherit"
                  className={styles.itemDescription}
                >
                  {roleDefinitions[EDITOR_ITEM.value]}
                </Text>
              </div>
            </SelectItem>
            {hasEditorAndViewerRoles && (
              <SelectItem
                value={VIEWER_ITEM.value}
                textValue={VIEWER_ITEM.label}
                className={styles.selectItem}
              >
                <div className={styles.itemContent}>
                  <Text
                    type="Body2"
                    color="inherit"
                    className={styles.itemLabel}
                  >
                    {VIEWER_ITEM.label}
                  </Text>
                  <Text
                    type="SmallPrint1"
                    color="inherit"
                    className={styles.itemDescription}
                  >
                    {roleDefinitions[VIEWER_ITEM.value]}
                  </Text>
                </div>
              </SelectItem>
            )}
          </SelectBaseListBox>
        </SelectBasePopover>
      </SelectBase>
    </div>
  );
}
